import {action, observable, makeObservable} from 'mobx';
import {Message} from '../types';

export class OB_Message {
    @observable message?: Message | null = null;

    @action setMessage = (err: Message) => {
        this.message = err;
    };

    @action clearMessage = () => {
        this.message = null;
    };

    constructor() {
        makeObservable(this);
    }
}

export const onboardingMessageStore = new OB_Message();
